import { DefaultResponseCodeEnum } from '@workalizer/shared';
export var deleteDocumentAlertConfig = function (input) {
    return {
        code: DefaultResponseCodeEnum.SUCCESS,
        success: true
    };
};
